<template>
    <div v-if="isUnavailable && showUnavailableWarning" style="display:flex; align-items:center; gap:0.6rem; padding:0.6rem 0.9rem; background:#fff3cd; border:1px solid #ffc107; border-radius:6px; font-size:0.875rem; color:#856404;">
        <i class="pi pi-exclamation-triangle"></i>
        Høydeprofilen kunne ikke tegnes fra GPX-filen. Filen mangler trolig høydedata.
    </div>
    <div v-else ref="chartContainer" style="height:220px;"></div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    routeId: { type: [Number, String], required: true },
    showUnavailableWarning: { type: Boolean, default: false },
});

const chartContainer = ref(null);
const isUnavailable = ref(false);

function renderChart(series) {
    window.Highcharts.chart(chartContainer.value, {
        chart: { type: 'areaspline', height: 220 },
        title: { text: 'Høydeprofil', style: { fontSize: '1rem' } },
        credits: { enabled: false },
        legend: { enabled: false },
        xAxis: {
            title: { text: 'Km' },
            labels: { format: '{value}' },
        },
        yAxis: {
            title: { text: 'Moh.' },
            min: null,
        },
        tooltip: {
            headerFormat: '',
            pointFormat: '{point.x} km: <b>{point.y} moh.</b>',
        },
        plotOptions: {
            areaspline: {
                fillOpacity: 0.2,
                color: '#ED6314',
                marker: { enabled: false },
                lineWidth: 2,
            },
        },
        series: [{
            name: 'Høyde',
            data: series.map((point) => [point.distance, point.elevation]),
        }],
    });
}

onMounted(async () => {
    if (!window.Highcharts) {
        return;
    }

    try {
        const response = await fetch('/xhr/frontend/routes/' + props.routeId + '/elevation-profile', {
            headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
            isUnavailable.value = true;
            return;
        }

        const data = await response.json();
        const series = data.series || [];

        if (series.length) {
            renderChart(series);
        } else {
            isUnavailable.value = true;
        }
    } catch (e) {
        isUnavailable.value = true;
    }
});
</script>
